module.exports = __webpack_public_path__ + "img/22.8621de8d.png";